import React from "react";
import "./styles.scss";
import { GetIconByName } from "../../config/icon";

const Index = ({ data, onClick }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div className={`tag-wrapper ${data.type}`} onClick={onClick}>
        {data.isIcon && data.tagIcon !== "" && (
          <div className={"tw__icon"}>{GetIconByName(data.tagIcon)}</div>
        )}
        <div className={"tw__name"}>{data.tagName}</div>
        {data.isIcon && data.tagIcon === "" && (
          <div className={"tw__icon"} onClick={onClick}>
            {GetIconByName("cross")}
          </div>
        )}
      </div>
    </>
  );

  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultProps = {};
export default Index;
